 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHTNOTICE from '@/components/xhtml/copyrightnotice'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLPROLOGUE from '@/components/xhtml/prologue'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLCHAPTER6 from '@/components/xhtml/chapter6'
 import XHTMLCHAPTER7 from '@/components/xhtml/chapter7'
 import XHTMLCHAPTER8 from '@/components/xhtml/chapter8'
 import XHTMLCHAPTER9 from '@/components/xhtml/chapter9'
 import XHTMLCHAPTER10 from '@/components/xhtml/chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/chapter11'
 import XHTMLCHAPTER12 from '@/components/xhtml/chapter12'
 import XHTMLCHAPTER13 from '@/components/xhtml/chapter13'
 import XHTMLEPILOGUE from '@/components/xhtml/epilogue'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTMLBIBLIOGRAPHY from '@/components/xhtml/bibliography'
 import XHTMLACKNOWLEDGMENTS from '@/components/xhtml/acknowledgments'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLADCARD from '@/components/xhtml/adcard'
 import XHTMLABOUTTHEAUTHOR from '@/components/xhtml/abouttheauthor'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/prologue",
 			"name" : "xhtml/prologue",
 			"component" : XHTMLPROLOGUE
 		},
 		{
 			"path" : "/xhtml/chapter1",
 			"name" : "xhtml/chapter1",
 			"component" : XHTMLCHAPTER1
 		},
 		{
 			"path" : "/xhtml/chapter2",
 			"name" : "xhtml/chapter2",
 			"component" : XHTMLCHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js